import { memo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { cdnImg } from "../Utils/cdnImage";
import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import { useContextSelector } from "use-context-selector";
import ThemeContext from "../context/ThemeContext";
const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  return (
    <div
      // style={{ marginBottom: "50px" }}
      className="footer-wrap ng-star-inserted"
    >
      <footer className="footer">
        {/* <div
          className="footer-collapse__logo"
          style={{
            "background-image":
              'url("/assets/Other/logo-dark.png?v=1772072361392")',
          }}
        /> */}
        {/* <div className="footer-collapse">
          <mcd-footer-description-en className="ng-star-inserted" style={{}}>
            <div className="footer-collapse__title ng-star-inserted">
              {t("FooterTitle")}
            </div>
            <div className="footer-collapse__content ng-star-inserted">
              <p>{t("FooterContent1")}</p>
              <br />
              <p>{t("FooterContent2")}</p>
              <br />
              <p>{t("FooterContent3")}</p>
              <br />
              <p>{t("FooterContent4")}</p>
              <br />
              <p>{t("FooterContent5")}</p>
              <br />
              <p>{t("FooterContent6")}</p>
              <br />
              <p>{t("FooterContent7")}</p>
            </div>
          </mcd-footer-description-en>

          <div className="footer-collapse__btn">
            {" "}
            {t("ReadMore")}{" "}
            <div
              className="footer-collapse__btn-arrow"
              style={{
                "mask-image":
                  'url("/assets/Footer/accordion-arrow.webp?v=1772072361392")',
              }}
            />
          </div>
        </div> */}
        <div style={{ width: "100%" }} className="row">
          <mcd-icon-list _nghost-serverapp-c1907600589 className="license">
            <div
              style={{
                background: theme == "dark" ? "#064b4d" : "#37383c",
                padding: "7px",
                borderRadius: "5px",
              }}
              _ngcontent-serverapp-c1907600589
              className="license ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c1907600589>{t("GamingLicense")}</h2>
              <ul _ngcontent-serverapp-c1907600589>
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    width={172}
                    height={56}
                    alt="license1"
                    src={cdnImg(
                      "/assets/Footer/license1.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    style={{ "aspect-ratio": "172 / 56" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="anjouan-egaming"
                    src={cdnImg(
                      "/assets/Footer/anjouan-egaming.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={142}
                    height={60}
                    style={{ "aspect-ratio": "142 / 60" }}
                  />
                </li>
              </ul>
            </div>
          </mcd-icon-list>
          <mcd-icon-list _nghost-serverapp-c1907600589 className="license">
            <div
              style={{
                     background: theme == "dark" ? "#064b4d" : "#37383c",
                padding: "7px",
                borderRadius: "5px",
              }}
              _ngcontent-serverapp-c1907600589
              className="license ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c1907600589>{t("ResponsibleGaming")}</h2>
              <ul
                style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
                _ngcontent-serverapp-c1907600589
              >
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    width={172}
                    height={56}
                    alt="license1"
                    src={"/assets/Footer/regulations.svg"}
                    loading="lazy"
                    className="ng-star-inserted"
                    style={{ "aspect-ratio": "172 / 56" }}
                  />
                </li>
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="anjouan-egaming"
                    src={"/assets/Footer/age-limit.svg"}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={142}
                    height={60}
                    style={{ "aspect-ratio": "142 / 60" }}
                  />
                </li>{" "}
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="anjouan-egaming"
                    src={"/assets/Footer/gamcare.svg"}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={142}
                    height={60}
                    style={{ "aspect-ratio": "142 / 60" }}
                  />
                </li>
              </ul>
            </div>
          </mcd-icon-list>
          <mcd-social-media-list _nghost-serverapp-c3151814184>
            <div
              style={{
                    background: theme == "dark" ? "#064b4d" : "#37383c",
                padding: "7px",
                borderRadius: "5px",
              }}
              _ngcontent-serverapp-c3151814184
              className="footer-social ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c3151814184>{t("CommunityWebsites")}</h2>
              <ul _ngcontent-serverapp-c3151814184>
                <li
                  _ngcontent-serverapp-c3151814184
                  className="ng-star-inserted"
                >
                  <a
                    _ngcontent-serverapp-c3151814184
                    target="_blank"
                    href="https://www.facebook.com/share/g/1L9iMChZUf/"
                    className="ng-star-inserted"
                  >
                    <img
                      _ngcontent-serverapp-c3151814184
                      alt="facebook"
                      fetchpriority="low"
                      src={cdnImg(
                        "/assets/Footer/facebook.webp?v=1772072361392&source=mcdsrc",
                      )}
                      loading="lazy"
                      width={22}
                      height={22}
                      style={{ "aspect-ratio": "22 / 22" }}
                    />
                  </a>
                </li>
                <li
                  _ngcontent-serverapp-c3151814184
                  className="ng-star-inserted"
                >
                  <a
                    _ngcontent-serverapp-c3151814184
                    target="_blank"
                    href="https://wa.me/13365284579"
                    className="ng-star-inserted"
                  >
                    <img
                      _ngcontent-serverapp-c3151814184
                      alt="whatsapp"
                      fetchpriority="low"
                      src={cdnImg(
                        "/assets/Footer/whatsapp.webp?v=1772072361392&source=mcdsrc",
                      )}
                      loading="lazy"
                      width={22}
                      height={22}
                      style={{ "aspect-ratio": "22 / 22" }}
                    />
                  </a>
                </li>
                {/* <li
                  _ngcontent-serverapp-c3151814184
                  className="ng-star-inserted"
                >
                  <a
                    _ngcontent-serverapp-c3151814184
                    target="_blank"
                    href="https://www.instagram.com/newcity.vip/"
                    className="ng-star-inserted"
                  >
                    <img
                      _ngcontent-serverapp-c3151814184
                      alt="instagram"
                      fetchpriority="low"
                      src={cdnImg("/assets/Footer/instagram.webp?v=1772072361392&source=mcdsrc")}
                      loading="lazy"
                      width={22}
                      height={22}
                      style={{ "aspect-ratio": "22 / 22" }}
                    />
                  </a>
                </li>

                <li
                  _ngcontent-serverapp-c3151814184
                  className="ng-star-inserted"
                >
                  <a
                    _ngcontent-serverapp-c3151814184
                    target="_blank"
                    href="https://t.me/newcityvip"
                    className="ng-star-inserted"
                  >
                    <img
                      _ngcontent-serverapp-c3151814184
                      alt="telegram-channel"
                      fetchpriority="low"
                      src={cdnImg("/assets/Footer/telegram-channel.webp?v=1772072361392&source=mcdsrc")}
                      loading="lazy"
                      width={150}
                      height={150}
                      style={{ "aspect-ratio": "150 / 150" }}
                    />
                  </a>
                </li>

                <li
                  _ngcontent-serverapp-c3151814184
                  className="ng-star-inserted"
                >
                  <a
                    _ngcontent-serverapp-c3151814184
                    target="_blank"
                    href="https://x.com/ncvip_southasia"
                    className="ng-star-inserted"
                  >
                    <img
                      _ngcontent-serverapp-c3151814184
                      alt="twitter"
                      fetchpriority="low"
                      src={cdnImg("/assets/Footer/twitter.webp?v=1772072361392&source=mcdsrc")}
                      loading="lazy"
                      width={150}
                      height={150}
                      style={{ "aspect-ratio": "150 / 150" }}
                    />
                  </a>
                </li> */}
              </ul>
            </div>
          </mcd-social-media-list>
        </div>
        <div className="row">
          <mcd-icon-list _nghost-serverapp-c1907600589 className="pay">
            <div
              style={{
                    background: theme == "dark" ? "#064b4d" : "#37383c",
                padding: "7px",
                borderRadius: "5px",
              }}
              _ngcontent-serverapp-c1907600589
              className="pay ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c1907600589>{t("PaymentMethods")}</h2>
              <ul _ngcontent-serverapp-c1907600589>
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay16"
                    src={cdnImg(
                      "/assets/Footer/pay16.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={122}
                    height={45}
                    style={{ "aspect-ratio": "122 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay22"
                    src={cdnImg(
                      "/assets/Footer/pay22.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={68}
                    height={30}
                    style={{ "aspect-ratio": "68 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay33"
                    src={cdnImg(
                      "/assets/Footer/pay33.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={46}
                    height={30}
                    style={{ "aspect-ratio": "46 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay34"
                    src={cdnImg(
                      "/assets/Footer/pay34.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={68}
                    height={30}
                    style={{ "aspect-ratio": "68 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay45"
                    src={cdnImg(
                      "/assets/Footer/pay45.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={87}
                    height={30}
                    style={{ "aspect-ratio": "87 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay48"
                    src={cdnImg(
                      "/assets/Footer/pay48.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={165}
                    height={30}
                    style={{ "aspect-ratio": "165 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay59"
                    src={cdnImg(
                      "/assets/Footer/pay59.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={122}
                    height={45}
                    style={{ "aspect-ratio": "122 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay60"
                    src={cdnImg(
                      "/assets/Footer/pay60.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={153}
                    height={45}
                    style={{ "aspect-ratio": "153 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay61"
                    src={cdnImg(
                      "/assets/Footer/pay61.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={39}
                    height={39}
                    style={{ "aspect-ratio": "39 / 39" }}
                  />
                </li>
              </ul>
            </div>
          </mcd-icon-list>
        </div>
        <div className="row">
          <mcd-about-us _nghost-serverapp-c3419815403 className="about-us">
            <div
              style={{
                   background: theme == "dark" ? "#064b4d" : "#37383c",
                padding: "7px",
                borderRadius: "5px",
              }}
              _ngcontent-serverapp-c3419815403
              className="about-us ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c3419815403>{t("ABOUTUS")}</h2>
              <ul _ngcontent-serverapp-c3419815403>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/responsiblegambling"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("ResponsibleGaming")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/privacypolicy"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("PrivacyPolicy")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/rulesandregulations"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {t("RulesAndRegulations")}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/18"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {t("18Plus")}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/aboutus"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("ABOUTUS")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/kyc"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {t("KYC")}
                  </Link>
                </li>

                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/termsandconditions"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("TermsConditions")}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </mcd-about-us>
        </div>
        <div className="footer__copyrights">
          <div className="footer__copyrights__info">
            <span>{t("Copyright")} </span>
          </div>
          <mcd-icon-list _nghost-serverapp-c1907600589 className="safe">
            <div
              _ngcontent-serverapp-c1907600589
              className="safe ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c1907600589>{t("ResponsibleGaming")}</h2>
              <ul _ngcontent-serverapp-c1907600589>
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="age-limit"
                    src={cdnImg(
                      "/assets/Footer/age-limit.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={150}
                    height={150}
                    style={{ "aspect-ratio": "150 / 150" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="regulations"
                    src={cdnImg(
                      "/assets/Footer/regulations.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={150}
                    height={150}
                    style={{ "aspect-ratio": "150 / 150" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="gamcare"
                    src={cdnImg(
                      "/assets/Footer/gamcare.webp?v=1772072361392&source=mcdsrc",
                    )}
                    loading="lazy"
                    className="ng-star-inserted"
                    width={150}
                    height={150}
                    style={{ "aspect-ratio": "150 / 150" }}
                  />
                </li>
              </ul>
            </div>
          </mcd-icon-list>
        </div>
      </footer>
    </div>
  );
};

export default memo(Footer);
